import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, TOKEN_KEY } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };

  const logout = async () => {
    await adminApi.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  const changePassword = async (current_password, new_password) => {
    const { data } = await adminApi.post("/auth/change-password", { current_password, new_password });
    localStorage.setItem(TOKEN_KEY, data.token);
  };

  return <AuthContext.Provider value={{ user, login, logout, changePassword }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
